export const GET_STORE_STATISTICS_START = 'GET_STORE_STATISTICS_START';
export const GET_STORE_STATISTICS_SUCCESS = 'GET_STORE_STATISTICS_SUCCESS';
export const GET_STORE_STATISTICS_FAILED = 'GET_STORE_STATISTICS_FAILED';

export const GET_SM_BANNERS_START = 'GET_SM_BANNERS_START';
export const GET_SM_BANNERS_SUCCESS = 'GET_SM_BANNERS_SUCCESS';
export const GET_SM_BANNERS_FAILED = 'GET_SM_BANNERS_FAILED';

export const CREATE_SM_BANNER_START = 'CREATE_SM_BANNER_START';
export const CREATE_SM_BANNER_SUCCESS = 'CREATE_SM_BANNER_SUCCESS';
export const CREATE_SM_BANNER_FAILED = 'CREATE_SM_BANNER_FAILED';

export const UPDATE_SM_BANNER_START = 'UPDATE_SM_BANNER_START';
export const UPDATE_SM_BANNER_SUCCESS = 'UPDATE_SM_BANNER_SUCCESS';
export const UPDATE_SM_BANNER_FAILED = 'UPDATE_SM_BANNER_FAILED';

export const DELETE_SM_BANNER_START = 'DELETE_SM_BANNER_START';
export const DELETE_SM_BANNER_SUCCESS = 'DELETE_SM_BANNER_SUCCESS';
export const DELETE_SM_BANNER_FAILED = 'DELETE_SM_BANNER_FAILED';

export const SEND_REQUEST_INFORMATION_EMAIL_START = 'SEND_REQUEST_INFORMATION_EMAIL_START';
export const SEND_REQUEST_INFORMATION_EMAIL_SUCCESS = 'SEND_REQUEST_INFORMATION_EMAIL_SUCCESS';
export const SEND_REQUEST_INFORMATION_EMAIL_FAILED = 'SEND_REQUEST_INFORMATION_EMAIL_FAILED';

export const GET_FUTURE_ASSIGNED_TASKS_START = 'GET_FUTURE_ASSIGNED_TASKS_START';
export const GET_FUTURE_ASSIGNED_TASKS_SUCCESS = 'GET_FUTURE_ASSIGNED_TASKS_SUCCESS';
export const GET_FUTURE_ASSIGNED_TASKS_FAILED = 'GET_FUTURE_ASSIGNED_TASKS_FAILED';

export const getStoreStatisticsStart = () => ({
  type: GET_STORE_STATISTICS_START,
});
export const getStoreStatisticsSuccess = (data) => ({
  type: GET_STORE_STATISTICS_SUCCESS,
  data
});
export const getStoreStatisticsFailed = (error) => ({
  type: GET_STORE_STATISTICS_FAILED,
  error
});

export const getSMBannersStart = () => ({
  type: GET_SM_BANNERS_START,
});
export const getSMBannersSuccess = (data) => ({
  type: GET_SM_BANNERS_SUCCESS,
  data
});
export const getSMBannersFailed = (error) => ({
  type: GET_SM_BANNERS_FAILED,
  error
});

export const createSMBannerStart = () => ({
  type: CREATE_SM_BANNER_START,
});
export const createSMBannerSuccess = (data) => ({
  type: CREATE_SM_BANNER_SUCCESS,
  data
});
export const createSMBannerFailed = (error) => ({
  type: CREATE_SM_BANNER_FAILED,
  error
});

export const updateSMBannerStart = () => ({
  type: UPDATE_SM_BANNER_START,
});
export const updateSMBannerSuccess = (data) => ({
  type: UPDATE_SM_BANNER_SUCCESS,
  data
});
export const updateSMBannerFailed = (error) => ({
  type: UPDATE_SM_BANNER_FAILED,
  error
});

export const deleteSMBannerStart = () => ({
  type: DELETE_SM_BANNER_START,
});
export const deleteSMBannerSuccess = (id, data) => ({
  type: DELETE_SM_BANNER_SUCCESS,
  id,
  data
});
export const deleteSMBannerFailed = (error) => ({
  type: DELETE_SM_BANNER_FAILED,
  error
});

export const sendRequestInformationEmailStart = () => ({
  type: SEND_REQUEST_INFORMATION_EMAIL_START,
});
export const sendRequestInformationEmailSuccess = (data) => ({
  type: SEND_REQUEST_INFORMATION_EMAIL_SUCCESS,
  data
});
export const sendRequestInformationEmailFailed = (error) => ({
  type: SEND_REQUEST_INFORMATION_EMAIL_FAILED,
  error
});


export const getFutureAssignedTasksStart = () => ({
  type: GET_FUTURE_ASSIGNED_TASKS_START
});

export const getFutureAssignedTasksSuccess = (data) => ({
  type: GET_FUTURE_ASSIGNED_TASKS_SUCCESS,
  data,
});

export const getFutureAssignedTasksFailed = (error) => ({
  type: GET_FUTURE_ASSIGNED_TASKS_FAILED,
  error
});
